"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilSigmaModelResolutionProperties = void 0;
const z = __importStar(require("zod"));
const hil_value_variance_js_1 = require("./hil-value-variance.js");
const hil_signal_js_1 = require("./hil-signal.js");
const merge_values_js_1 = require("../utils/merge-values.js");
const merge_records_js_1 = require("../utils/merge-records.js");
const merge_arrays_js_1 = require("../utils/merge-arrays.js");
const merge_arrays_dto_schema_js_1 = require("../utils/merge-arrays-dto-schema.js");
const merge_records_dto_schema_js_1 = require("../utils/merge-records-dto-schema.js");
const hilSigmaModelResolutionPropertiesSchema = z.object({
    sigmaModelType: z.string().default('ic.generic'),
    parameters: z.record(z.string(), hil_value_variance_js_1.HilValueVariance.schema).prefault({}),
    signals: hil_signal_js_1.HilSignal.schema.array().default([]),
});
const hilSigmaModelResolutionPropertiesDtoSchema = z.object({
    sigmaModelType: z.string().optional(),
    parameters: (0, merge_records_dto_schema_js_1.mergeRecordsDtoSchema)(hil_value_variance_js_1.HilValueVariance.schema, hil_value_variance_js_1.HilValueVariance.dtoSchema).optional(),
    signals: (0, merge_arrays_dto_schema_js_1.mergeArraysDtoSchema)(z.union([z.string(), z.number()]), hil_signal_js_1.HilSignal.schema, hil_signal_js_1.HilSignal.dtoSchema).optional(),
});
exports.HilSigmaModelResolutionProperties = {
    create: (input) => {
        return hilSigmaModelResolutionPropertiesSchema.parse(input);
    },
    merge: (existing, incoming) => ({
        sigmaModelType: (0, merge_values_js_1.mergeValues)(existing.sigmaModelType, incoming.sigmaModelType),
        parameters: (0, merge_records_js_1.mergeRecords)(existing.parameters, incoming.parameters, hil_value_variance_js_1.HilValueVariance.merge),
        signals: (0, merge_arrays_js_1.mergeArrays)(existing.signals, incoming?.signals, hil_signal_js_1.HilSignal.merge),
    }),
    schema: hilSigmaModelResolutionPropertiesSchema,
    dtoSchema: hilSigmaModelResolutionPropertiesDtoSchema,
};
//# sourceMappingURL=hil-sigma-model-resolution-properties.js.map